import { createBrandingTheme } from '@/lib/theme';

export const DEFAULT_BRANDING = {
  scheme: 'gym',
  app_name: 'NORI',
  tagline: 'the simple CRM',
  logo_url: null,
  logo_dark_url: null,
  favicon_url: null,
  login_bg_light_url: null,
  login_bg_dark_url: null,

  primary_color: '#CEFB52',
  primary_contrast: '#0F0F10',
  secondary_color: '#1F7CFF',
  error_color: '#FF5C5C',
  warning_color: '#FF2FB8',

  primary_color_light: '#171717',
  primary_contrast_light: '#CEFB52',
  secondary_color_light: '#1F7CFF',
  error_color_light: '#E04848',
  warning_color_light: '#D6219C',

  font_heading: 'Geist',
  font_body: 'Geist',
  font_family: null,

  border_radius: 12,
  default_mode: 'dark',
  extras: {},
};

export const buildTheme = (branding = DEFAULT_BRANDING, mode = 'dark') =>
  createBrandingTheme(branding, mode);

export const gymTheme = buildTheme(DEFAULT_BRANDING, 'dark');
